import React, { useCallback, useState } from "react";
import { useFocusEffect } from "expo-router";

import CollapsableAccount from "./Components/CollapsableAccount";

import ScreenLayout from "@/Components/Layouts/Native/ScreenLayout";
import { type AppUserSession } from "@/schemas/auth/session";
import { type UserProfile } from "@/schemas/user/profile";
import ProfileService from "@/services/user/profile";
import { useSession } from "@/context/auth/useSession";

type AccountScreenProps = {
  session: AppUserSession;
};

function AccountScreen({ session }: AccountScreenProps): React.JSX.Element {
  const profileService = new ProfileService(session);
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { refreshUserIdentity } = useSession();

  const fetchAccount = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const username = session.identity.username;
      const profile = await profileService.getUserProfile(username);
      setProfile(profile);
    } finally {
      setIsLoading(false);
    }
  };

  useFocusEffect(
    useCallback(() => {
      fetchAccount();
      refreshUserIdentity();
    }, []),
  );

  return (
    <ScreenLayout isLoading={isLoading}>
      {profile !== null && (
        <CollapsableAccount
          session={session}
          profile={profile}
          onRefresh={fetchAccount}
        />
      )}
    </ScreenLayout>
  );
}
export default AccountScreen;
